<template>
    <b-card>
        <template v-if="!selectedFuelType">
            <div class="border rounded d-flex mb-2 bg-white">
                <div class="d-flex align-items-center justify-content-center border-right bg-primary text-white font-weight-bold rounded-left" style="width: 25px; writing-mode: vertical-rl; transform: rotate(180deg); user-select: none">AdBlue</div>
                <div class="flex-grow-1 py-2 px-50">
                    <div class="row m-0">
                        <div v-for="(stat, index) in adBlueGlobalStats" :key="'adblue-' + index" class="col-md-3 px-1">
                            <VStatsBox v-bind="stat" class="mb-0 h-100 shadow-lg" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="border rounded d-flex mb-3 bg-white">
                <div class="d-flex align-items-center justify-content-center border-right bg-warning text-white font-weight-bold rounded-left" style="width: 25px; writing-mode: vertical-rl; transform: rotate(180deg); user-select: none">Motorin</div>
                <div class="flex-grow-1 py-2 px-50">
                    <div class="row m-0">
                        <div v-for="(stat, index) in motorinGlobalStats" :key="'motorin-' + index" class="col-md-3 px-1">
                            <VStatsBox v-bind="stat" class="mb-0 h-100 shadow-lg" />
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div v-else-if="summaryStats.length > 0" class="row mb-2">
            <div v-for="(stat, index) in summaryStats" :key="index" class="col-md-3">
                <VStatsBox v-bind="stat" />
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4">
                <label><span class="font-weight-bold">Yakıt Tipi</span></label>
                <v-select v-model="selectedFuelType" :options="fuelTypeSelectItems" label="name" placeholder="Seçiniz..." clearable />
            </div>
            <div class="col-md-4">
                <label><span class="font-weight-bold">Şube</span></label>
                <v-select v-model="selectedBranch" :options="branchSelectItems" :disabled="!selectedFuelType" label="name" placeholder="Seçiniz..." clearable />
            </div>
            <div class="col-md-4">
                <label><span class="font-weight-bold">Depo</span></label>
                <v-select v-model="selectedDepot" :options="depotSelectItems" :disabled="!selectedBranch" label="DisplayName" placeholder="Seçiniz..." clearable />
            </div>
        </div>

        <hr class="mb-2" />

        <div v-if="!loading" class="row d-flex align-items-stretch mb-0">
            <template v-if="!selectedFuelType">
                <div v-if="adBlueGlobalSummary" class="col-md-6 d-flex flex-column mb-1">
                    <div class="d-flex align-items-center justify-content-between mb-50 ml-1 mr-1">
                        <h5 class="mb-0 font-weight-bold text-secondary">Tüm Depolar</h5>
                        <span class="badge badge-primary badge-pill ml-2 px-2" style="font-size: 0.75rem; vertical-align: middle">AdBlue</span>
                    </div>
                    <div class="border rounded p-2 flex-grow-1 position-relative">
                        <fuel-storage-bar-chart :summary-data="adBlueGlobalSummary" />
                    </div>
                </div>

                <div v-if="motorinGlobalSummary" class="col-md-6 d-flex flex-column mb-1">
                    <div class="d-flex align-items-center justify-content-between mb-50 ml-1 mr-1">
                        <h5 class="mb-0 font-weight-bold text-secondary">Tüm Depolar</h5>
                        <span class="badge badge-warning badge-pill ml-2 px-2 text-white" style="font-size: 0.75rem; vertical-align: middle">Motorin</span>
                    </div>
                    <div class="border rounded p-2 flex-grow-1 position-relative">
                        <fuel-storage-bar-chart :summary-data="motorinGlobalSummary" />
                    </div>
                </div>
            </template>
            <div v-if="selectedFuelType && fuelTypeSummary" class="col-md-4 d-flex flex-column mb-1">
                <h4 class="text-center">Tüm Depolar</h4>
                <div class="border rounded p-2 flex-grow-1 position-relative">
                    <fuel-storage-bar-chart :summary-data="fuelTypeSummary" />
                </div>
            </div>

            <div v-if="selectedBranch && branchSummary" class="col-md-4 d-flex flex-column mb-1">
                <h4 class="text-center">{{ selectedBranch.name }}</h4>
                <div class="border rounded p-2 flex-grow-1 position-relative">
                    <fuel-storage-bar-chart :summary-data="branchSummary" />
                </div>
            </div>

            <div v-if="selectedDepot && depotSummary" class="col-md-4 d-flex flex-column mb-1">
                <h4 class="text-center">{{ selectedDepot.FuelStorageName }}</h4>
                <div class="border rounded p-2 flex-grow-1 position-relative">
                    <fuel-storage-bar-chart :summary-data="depotSummary" />
                </div>
            </div>
        </div>

        <div v-else class="text-center">
            <b-spinner />
            <p>Veriler yükleniyor...</p>
        </div>
    </b-card>
</template>

<script>
import { BCard, BSpinner } from "bootstrap-vue";
import vSelect from "vue-select";
import FuelStorageApi from "@/api/fuel-storage";
import FuelStorageBarChart from "./components/FuelStorageBarChart.vue";
import VStatsBox from "@/components/VStatsBox.vue";

export default {
    name: "FuelStorageOccupancyBarChartView",
    components: {
        BCard,
        BSpinner,
        vSelect,
        FuelStorageBarChart,
        VStatsBox,
    },
    data() {
        return {
            loading: false,
            allStorages: [],
            selectedFuelType: null,
            selectedBranch: null,
            selectedDepot: null,
        };
    },
    computed: {
        currentlyFilteredStorages() {
            if (!this.selectedFuelType) return [];

            let items = this.allStorages.filter((depot) => depot.FuelTypeName === this.selectedFuelType.name);

            if (this.selectedBranch) {
                items = items.filter((depot) => depot.BranchName === this.selectedBranch.name);
            }
            if (this.selectedDepot) {
                items = items.filter((depot) => depot.FuelStorageId === this.selectedDepot.FuelStorageId);
            }
            return items;
        },
        summaryStats() {
            return this.generateSummaryStats(this.currentlyFilteredStorages);
        },
        fuelTypeSelectItems() {
            const uniqueFuelTypes = [...new Set(this.allStorages.map((depot) => depot.FuelTypeName))];
            return uniqueFuelTypes.map((name) => ({ name: name }));
        },

        branchSelectItems() {
            if (!this.selectedFuelType) return [];
            const filteredByFuel = this.allStorages.filter((depot) => depot.FuelTypeName === this.selectedFuelType.name);
            const uniqueBranches = [...new Set(filteredByFuel.map((depot) => depot.BranchName))];
            return uniqueBranches.map((name) => ({ id: name, name: name }));
        },

        depotSelectItems() {
            if (!this.selectedBranch || !this.selectedFuelType) return [];
            return this.allStorages
                .filter((depot) => depot.BranchName === this.selectedBranch.name && depot.FuelTypeName === this.selectedFuelType.name)
                .map((depot) => ({
                    ...depot,
                    DisplayName: `${depot.FuelStorageName} [${(depot.Capacity || 0).toLocaleString("tr-TR")} lt]`,
                }));
        },

        fuelTypeSummary() {
            if (!this.selectedFuelType) return null;
            const filtered = this.allStorages.filter((depot) => depot.FuelTypeName === this.selectedFuelType.name);
            return this.calculateSummary(filtered);
        },

        branchSummary() {
            if (!this.selectedBranch || !this.selectedFuelType) return null;
            const filtered = this.allStorages.filter((depot) => depot.BranchName === this.selectedBranch.name && depot.FuelTypeName === this.selectedFuelType.name);
            return this.calculateSummary(filtered);
        },

        depotSummary() {
            if (!this.selectedDepot) return null;
            return this.calculateSummary([this.selectedDepot]);
        },

        adBlueStorages() {
            return this.allStorages.filter((s) => s.FuelTypeName === "AdBlue");
        },

        motorinStorages() {
            return this.allStorages.filter((s) => s.FuelTypeName === "Motorin");
        },

        adBlueGlobalSummary() {
            return this.calculateSummary(this.adBlueStorages);
        },

        motorinGlobalSummary() {
            return this.calculateSummary(this.motorinStorages);
        },

        adBlueGlobalStats() {
            return this.generateSummaryStats(this.adBlueStorages);
        },

        motorinGlobalStats() {
            return this.generateSummaryStats(this.motorinStorages);
        },
    },

    watch: {
        selectedFuelType() {
            this.selectedBranch = null;
            this.selectedDepot = null;
        },
        selectedBranch() {
            this.selectedDepot = null;
        },
    },

    created() {
        this.fetchData();
    },

    methods: {
        generateSummaryStats(data) {
            if (!data || data.length === 0) {
                return [];
            }

            const totalCapacity = data.reduce((sum, s) => sum + s.Capacity, 0);
            const totalStock = data.reduce((sum, s) => sum + s.CurrentStock, 0);
            const occupancyRate = totalCapacity > 0 ? (totalStock / totalCapacity) * 100 : 0;

            return [
                { text: "Toplam Depo Sayısı", value: data.length, icon: "inventory_2", variant: "primary" },
                { text: "Toplam Kapasite [lt]", value: totalCapacity.toLocaleString("tr-TR"), icon: "oil_barrel", variant: "success" },
                { text: "Mevcut Stok [lt]", value: totalStock.toLocaleString("tr-TR"), icon: "opacity", variant: "info" },
                { text: "Doluluk Oranı [%]", value: occupancyRate.toLocaleString("tr-TR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }), icon: "speed", variant: "warning" },
            ];
        },
        fetchData() {
            this.loading = true;
            FuelStorageApi.FuelStorageReport.GetFuelStorageStockLevelReport({})
                .then((response) => {
                    if (response.data.Success) {
                        this.allStorages = response.data.Data;
                    } else {
                        console.error("API'den veri alınamadı:", response.data.Message);
                    }
                })
                .catch((error) => {
                    console.error("API isteği başarısız:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        calculateSummary(storages) {
            if (!storages || storages.length === 0) return null;

            const totals = storages.reduce(
                (acc, depot) => {
                    acc.capacity += depot.Capacity;
                    acc.quantity += depot.CurrentStock;
                    acc.minStockLevel += depot.MinStockLevel;
                    acc.criticalStockLevel += depot.CriticalStockLevel;
                    return acc;
                },
                { capacity: 0, quantity: 0, minStockLevel: 0, criticalStockLevel: 0 }
            );

            const emptySpace = totals.capacity - totals.quantity;
            const avgStockLevel = totals.capacity / 2;
            const minStockPercentage = totals.capacity > 0 ? (totals.minStockLevel / totals.capacity) * 100 : 0;
            const criticalStockPercentage = totals.capacity > 0 ? (totals.criticalStockLevel / totals.capacity) * 100 : 0;

            return {
                ...totals,
                emptySpace: emptySpace,
                percentage: totals.capacity > 0 ? (totals.quantity / totals.capacity) * 100 : 0,

                capacityStr: totals.capacity.toLocaleString("tr-TR"),
                quantityStr: totals.quantity.toLocaleString("tr-TR"),
                emptySpaceStr: emptySpace.toLocaleString("tr-TR"),
                avgStockStr: avgStockLevel.toLocaleString("tr-TR"),
                minStockStr: totals.minStockLevel.toLocaleString("tr-TR"),
                criticalStockStr: totals.criticalStockLevel.toLocaleString("tr-TR"),
                percentageStr: (totals.capacity > 0 ? (totals.quantity / totals.capacity) * 100 : 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                emptySpacePercentageStr: (totals.capacity > 0 ? (emptySpace / totals.capacity) * 100 : 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                minStockPercentage: minStockPercentage,
                criticalStockPercentage: criticalStockPercentage,
                minStockPercentageStr: minStockPercentage.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                criticalStockPercentageStr: criticalStockPercentage.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            };
        },
    },
};
</script>
